import {Component, ElementRef, OnInit, OnDestroy, Renderer2, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {SubscriptionsService} from '../../_services/subscriptions.service';
import {ActivatedRoute, Router} from '@angular/router';
import * as globals from '../../settings';
import {LotteriesService} from '../../lotteries.service';
import {LoginService} from '../navigation/login.service';
import {UserService} from '../../_services/user.service';
import {GameLauncherService} from '../../_services/game-launcher.service';
import {CurrencyService} from '../../_services/currency.service';
import {GetPaymentMethodsService} from '../paymentMethod/get-payment-methods.service';
import {CookieService} from 'ngx-cookie-service';
import {PaystackSupportService} from '../paystack-support.service';
import {BonusService} from '../../_services/bonus.service';

interface Bank {
  id: number
  name: string
  selectDisplayName: string
  selectImageClass: string
  bank_id: string
  account_name: string
  account_number: string
  bank_address: string
  free_text: string
}

@Component({
  selector: 'app-add-funds-modal',
  templateUrl: './add-funds-modal.component.html',
  styleUrls: ['./add-funds-modal.component.scss']
})
export class AddFundsModalComponent implements OnInit, OnDestroy {
  noFunds: boolean;
  userNeedIncreaseBalance: Subscription;
  modalState: Subscription;
  toggleScratchContent: Subscription;
  language: string;
  amount: any[];
  selectedValue: any;
  selectedValueFromBackend: number;
  user: any;
  noMethods: boolean;
  IsPaymentOptions: boolean;
  selected_method: any;
  selected_method_class: any;
  selected_method_class_brand: any;
  chosenOption: any;
  payment_methods: any;
  pm_incentive: any;
  flipIt: number;
  flipperFlip: number;
  gameId: any;
  paymentCover: boolean;
  paymentSuccess: boolean;
  error52: any;
  error69: any;
  errorDefault: any;
  errorParams: any;
  paymentCoverShow: boolean;
  paymentCoverHide: boolean;
  isMobile: boolean;
  languageChange: Subscription;
  forceStepTwo: Subscription;
  methodSubscription: Subscription;
  enableButton: boolean;
  isSafari: boolean;
  enterAnimation: string;
  exitAnimation: string;
  isAddFundsOpenSubscription: Subscription;
  userNeedMoreMoney: Subscription;
  thisIsNewUser: Subscription;
  isAddFundsModalOpen: boolean;
  selected_method_show_name: string;
  casino: boolean;
  color: string;
  isModalClosing: Subscription;
  changedCurrency: Subscription;
  currency: any;
  paymentNameForText: any;
  @ViewChild('modalContainer') modalContainer: ElementRef;
  getPaymentMethodsSub: Subscription;
  gpmData: any;
  secureError: any;
  showOnlyPM: boolean;
  onlyPmStep: Subscription;
  info3d: boolean;
  brand = globals.brand;
  amountFromLink: any;
  paystackFlow: boolean;
  subscription: Subscription;
  cartItems: number;
  subFakeCart: Subscription;
  showAddFundsModal: Subscription;
  fakeCart: boolean;
  freshRegistered: boolean;
  minimumDepositFromBackend: any;
  blockedBecauseMinimumDeposit: boolean;
  blockedBecauseMinimumDepositShowError: boolean;
  typingTimer: any;
  holdSelectedValue: number;
  showLang: any;
  getGameClose: Subscription;
  subsGetAddPmOpen: Subscription;
  hideBecaouseEndOfGame: boolean;
  ifGetAddPmOpen: boolean;
  showConfirmation: boolean;
  fLogin: Subscription;
  afterLogin: boolean;
  wireTransferBanks: Bank[]
  selectedBank: string
  selectedBankDetails: Bank
  isWireTransferOption: boolean

  constructor(public subscriptionsService: SubscriptionsService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private loginService: LoginService,
              public lotteryService: LotteriesService,
              public userService: UserService,
              private renderer: Renderer2,
              private gameLauncher: GameLauncherService,
              private el: ElementRef,
              public currencyService: CurrencyService,
              public getpmService: GetPaymentMethodsService,
              public cookieService: CookieService,
              public paystackSupport: PaystackSupportService,
              private bonusService: BonusService) {
    this.showLang = localStorage.getItem('pageLanguage');
    this.blockedBecauseMinimumDeposit = false;
    this.blockedBecauseMinimumDepositShowError = false;

    this.thisIsNewUser = this.subscriptionsService.getNewUser().subscribe(data => {
      if (data) {
        this.freshRegistered = true;
        setTimeout(() => {
          this.freshRegistered = false;
        }, 2500);
      } else {
        this.freshRegistered = false;
      }
    });

    this.subsGetAddPmOpen = this.subscriptionsService.getAddPmOpen().subscribe(ifGetAddPmOpen => {
      this.ifGetAddPmOpen = ifGetAddPmOpen;
    });

    this.getGameClose = this.subscriptionsService.getIfGameClose().subscribe(data => {
      if (data) {
        this.hideBecaouseEndOfGame = true;
        setTimeout(() => {
          if (!this.ifGetAddPmOpen) {
            this.noFunds = false;
            this.isAddFundsModalOpen = false;
            this.hideBecaouseEndOfGame = false;
          }
        }, 5000);
      }
    });

    this.enterAnimation = 'slide-in-blurred-bottom';
    this.exitAnimation = 'slide-out-blurred-bottom';
    this.noFunds = false;
    this.userNeedMoreMoney = this.subscriptionsService.getUserNeedMoreMoney().subscribe(data => {
      this.userService.getUser();
      if (this.gameLauncher.gameId !== undefined) {
        this.gameId = this.gameLauncher.gameId;
      } else {
        this.gameId = -1;
      }
      this.casino = true;
      this.color = 'dark';
      this.noFunds = true;
      this.paymentCover = false;
      this.flipIt = 2;
      if (this.amount) {
        if (this.selectedValueFromBackend) {
          this.selectedValue = this.selectedValueFromBackend;
        } else {
          this.selectedValue = this.amount[1].amount;
        }
      }
      this.chosenOption = 0;
      this.getPaymentMethods();
      this.paystackSupport.checkIfPaystack();
      this.isAddFundsModalOpen = true;
      this.hideBecaouseEndOfGame = false;
    });
    this.subscription = this.subscriptionsService.getCartItems().subscribe(cartLength => {
      this.cartItems = cartLength;
    });
    this.fakeCart = false;
    this.subFakeCart = this.subscriptionsService.getFakeCart().subscribe(fc => {
      this.fakeCart = fc;
    });
    this.userNeedIncreaseBalance = this.subscriptionsService.getUserNeedIncraseBalance().subscribe(data => {
      if (this.brand !== 'winaija' || !this.freshRegistered) {
        if (!this.fakeCart || this.subscriptionsService.forceOpen) {
          this.runModal();
          this.subscriptionsService.forceOpen = false;
        }
        if (this.gameLauncher.gameId !== undefined) {
          this.gameId = this.gameLauncher.gameId;
        } else {
          this.gameId = -1;
        }
        this.noFunds = true;
        this.paymentCover = false;
        this.flipIt = 1;
        if (this.amount) {
          if (this.selectedValueFromBackend) {
            this.selectedValue = this.selectedValueFromBackend;
          } else {
            this.selectedValue = this.amount[1].amount;
          }
        }
        this.chosenOption = 0;
        if (this.router.url === '/' + this.language + '/casino') {
          this.casino = true;
          this.color = 'dark';
        } else {
          this.casino = false;
          this.color = 'light';
        }
        this.getPaymentMethods();
        this.paystackSupport.checkIfPaystack();
      } else {
        setTimeout(() => {
          this.freshRegistered = false;
        }, 500);
      }
    });

    this.showAddFundsModal = this.subscriptionsService.getShowAddFundsModal().subscribe(data => {
      if (data) {
        setTimeout(() => {
          this.isAddFundsModalOpen = true;
          this.getPaymentMethods();
          this.noFunds = true;
          this.flipIt = 2;
          this.flipperFlip = 2;
        }, 500);
      }
    });

    this.languageChange = this.subscriptionsService.getLanguage().subscribe(lang => {
      this.language = lang;
      this.paystackSupport.checkIfPaystack();
    });

    this.modalState = this.subscriptionsService.getAddFundsModalState().subscribe(data => {
      this.flipIt = 1;
      this.flipperFlip = 1;
      this.paystackSupport.checkIfPaystack();
    });

    this.forceStepTwo = this.subscriptionsService.getForceStepTwo().subscribe(data => {
      this.flipIt = 2;
      this.flipperFlip = 2;
      this.paystackSupport.checkIfPaystack();
    });

    this.methodSubscription = this.subscriptionsService.getUpdateMethod().subscribe(update => {
      this.getPaymentMethods();
    });

    this.afterLogin = false;
    this.fLogin = this.subscriptionsService.getFreshLogin().subscribe(freshLogin => {
      this.afterLogin = freshLogin;
      if (freshLogin) {
        setTimeout(() => {
          this.isAddFundsModalOpen = false;
          this.subscriptionsService.emitFreshLogin(false);
        }, 2500);
      }
    });


    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1) {
      if (ua.indexOf('chrome') === -1) {
        this.isSafari = true;
      }
    }

    this.isAddFundsOpenSubscription = this.subscriptionsService.getIsAddFundsOpen().subscribe(isAddFundsOpen => {
      this.isAddFundsModalOpen = isAddFundsOpen;
      if (localStorage.getItem('freshAddedPaymentMethodId')) {
        this.getPaymentMethods();
      }
      this.userService.getUser();
      this.paystackSupport.checkIfPaystack();
    });
    this.isModalClosing = this.subscriptionsService.getIfModalClosing().subscribe(data => {
      if (data) {
        this.blockedBecauseMinimumDepositShowError = false;
        this.blockedBecauseMinimumDeposit = false;
        this.paymentCoverHide = false;
        this.paymentCover = false;
        this.errorDefault = false;
        this.error52 = false;
        this.error69 = false;
        this.secureError = false;
      }
    });

    this.currency = this.currencyService.currency;
    this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
      if (currency) {
        this.currency = currency;
      }
      this.paystackSupport.checkIfPaystack();
    });

    this.getPaymentMethodsSub = this.subscriptionsService.getPaymentMethods().subscribe(gpm => {
      this.gpmData = gpm;
      if (gpm &&
        gpm.message &&
        gpm.message.DepositAmounts &&
        gpm.message.DepositAmounts.firstValue &&
        gpm.message.DepositAmounts.secondValue &&
        gpm.message.DepositAmounts.thirdValue) {
        if (gpm.message.DepositAmounts.fourthValue) {
          this.amount = [
            {'amount': gpm.message.DepositAmounts.firstValue},
            {'amount': gpm.message.DepositAmounts.secondValue},
            {'amount': gpm.message.DepositAmounts.thirdValue},
            {'amount': gpm.message.DepositAmounts.fourthValue}
          ];
        } else {
          this.amount = [
            {'amount': gpm.message.DepositAmounts.firstValue},
            {'amount': gpm.message.DepositAmounts.secondValue},
            {'amount': gpm.message.DepositAmounts.thirdValue}
          ];
        }
        if (gpm.message.DepositAmounts.selectedValue) {
          this.selectedValueFromBackend = gpm.message.DepositAmounts.selectedValue;
          this.selectedValue = gpm.message.DepositAmounts.selectedValue;
        }
        if (gpm.message.DepositAmounts.minimum) {
          this.minimumDepositFromBackend = gpm.message.DepositAmounts.minimum;
        } else {
          this.minimumDepositFromBackend = -1;
        }
      }
      this.paystackSupport.checkIfPaystack();
    });

    this.subscriptionsService.getLoggedInStatus().subscribe(data => {
      if (data === false) {
        this.payment_methods = null;
      }
      this.paystackSupport.checkIfPaystack();
    });

    this.getpmService.getPaymentMethods();

    this.showOnlyPM = false;
    this.onlyPmStep = this.subscriptionsService.getOnlyPmStep().subscribe(onlyPmStep => {
      this.showOnlyPM = onlyPmStep;
      this.paystackSupport.checkIfPaystack();
    });
  }

  ngOnInit() {
    this.casino = false;
    this.color = 'light';
    this.IsPaymentOptions = false;
    const url = new URL(window.location.href);
    const triggerModal = url.searchParams.get('trigger-modal');
    const paymentStatus = url.searchParams.get('paymentStatus');

    if (window.location.href.indexOf('casino') <= -1 || this.freshRegistered === false ||
      triggerModal === 'true' || paymentStatus === 'fail') {
      this.isAddFundsModalOpen = true;
    }
    this.enableButton = false;
    this.paymentCover = false;
    this.flipIt = 1;
    this.chosenOption = 0;
    this.userService.getUser();
    setTimeout(() => {
      this.language = localStorage.getItem('pageLanguage');
    }, 500);
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['trigger-modal'] === 'true') {
        this.subscriptionsService.emitCloseDepositModalSmoothly(true);
        setTimeout(() => {
          this.subscriptionsService.emitCloseDepositModalSmoothly(false);
          this.userService.getUserDetails(this.userService.userData.sessionId, this.userService.userData.memberId,
            false).then(output => {
            if (output === 'user') {
              this.selectedValue = params['deposit-amount'];
              this.amountFromLink = params['deposit-amount'];
              this.gameId = params['game-id'];
              this.noFunds = true;
              this.paymentCover = false;
              this.flipIt = 3;
              this.chosenOption = 0;
              this.getPaymentMethods();
              const url: string = this.router.url.substring(0, this.router.url.indexOf('?'));
              this.router.navigateByUrl(url);
            }
          });
        }, 500);
      }
      if (params['paymentStatus'] === 'fail') {
        setTimeout(() => {
          this.checkForPaymentMethods(params['game-id']);
        }, 500);
      }
    });

    this.paystackSupport.checkIfPaystack();
    this.selectedBank = null
  }

  checkForPaymentMethods(gameId) {
    if (this.getpmService.gpm_tmp) {
      this.failPayment(gameId);
    } else {
      setTimeout(() => {
        this.checkForPaymentMethods(gameId);
      }, 500);
    }
  }

  failPayment(gameId) {
    if (localStorage.getItem('error3dSecure')) {
      this.secureError = JSON.stringify(localStorage.getItem('error3dSecure')).replace(/"/g, '');
    }
    if (this.selectedValueFromBackend) {
      this.selectedValue = this.selectedValueFromBackend;
    } else {
      this.selectedValue = this.amount[1].amount;
    }
    this.gameId = gameId;
    this.noFunds = true;
    this.getPaymentMethods();
    this.flipperFlip = 2;
    this.flipIt = 2;
    this.chosenOption = 0;
    if (this.secureError) {

    } else {
      this.errorDefault = true;
    }
    this.paymentCover = true;
    setTimeout(() => {
      this.paymentCoverShow = true;
    }, 200);
    const url: string = this.router.url.substring(0, this.router.url.indexOf('?'));
    this.router.navigateByUrl(url);
  }

  ngOnDestroy() {
    this.modalState.unsubscribe();
    this.userNeedIncreaseBalance.unsubscribe();
    if (this.changedCurrency) {
      this.changedCurrency.unsubscribe();
    }
    if (this.getPaymentMethodsSub) {
      this.getPaymentMethodsSub.unsubscribe();
    }
    if (this.onlyPmStep) {
      this.onlyPmStep.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subFakeCart) {
      this.subFakeCart.unsubscribe();
    }
    if (this.showAddFundsModal) {
      this.showAddFundsModal.unsubscribe();
    }
    if (this.methodSubscription) {
      this.methodSubscription.unsubscribe();
    }
    if (this.thisIsNewUser) {
      this.thisIsNewUser.unsubscribe();
    }
    if (this.getGameClose) {
      this.getGameClose.unsubscribe();
    }
    if (this.subsGetAddPmOpen) {
      this.subsGetAddPmOpen.unsubscribe();
    }
    if (this.fLogin) {
      this.fLogin.unsubscribe();
    }
    this.amountFromLink = false;
  }

  runModal() {
    this.isAddFundsModalOpen = true;

    if (this.gameLauncher.gameId !== undefined) {
      this.gameId = this.gameLauncher.gameId;
    } else {
      this.gameId = -1;
    }
    this.noFunds = true;
    this.paymentCover = false;
    this.flipIt = 1;
    if (this.amount) {
      if (this.selectedValueFromBackend) {
        this.selectedValue = this.selectedValueFromBackend;
      } else {
        this.selectedValue = this.amount[1].amount;
      }
    }
    this.chosenOption = 0;
    if (this.router.url === '/' + this.language + '/casino') {
      this.casino = true;
      this.color = 'dark';
    } else {
      this.casino = false;
      this.color = 'light';
    }
    this.getPaymentMethods();
  }

  addMethod() {
    this.language = localStorage.getItem('pageLanguage');
    localStorage.setItem('dashboardStatus', 'add-funds');
    this.router.navigate(['/' + this.language, 'dashboard']);
    this.subscriptionsService.emitAddFunds(true);
    this.subscriptionsService.emitGoToAPM(true);
    this.subscriptionsService.closeModalNow(true);
    this.subscriptionsService.emitToggleContent(true);
    this.flipIt = 1;
    this.flipperFlip = 1;
  }

  goToRegistration() {
    localStorage.setItem('isOpenRegister', 'true');
    this.renderer.addClass(document.body, 'modal-open-register');
    setTimeout(() => {
      localStorage.removeItem('isOpenRegister');
    }, 50);
    this.subscriptionsService.emitRegister(true);
  }

  runAddPM() {
    this.subscriptionsService.emitCloseDepositModalSmoothly(true);
    setTimeout(() => {
      this.subscriptionsService.emitCloseDepositModalSmoothly(false);
      this.isAddFundsModalOpen = false;
      this.renderer.removeClass(document.body, 'modal-open');
      this.subscriptionsService.onlyPmStep(true);
      this.showOnlyPM = true;
      setTimeout(() => {
        this.goToRegistration();
      }, 50);
    }, 500);
  }

  setAmount(value) {
    this.blockedBecauseMinimumDepositShowError = false;
    this.blockedBecauseMinimumDeposit = false;
    this.selectedValue = value;
  }

  validateAmount(event) {
    if (!((event.keyCode >= 48 && event.keyCode <= 57) ||
      (event.keyCode >= 96 && event.keyCode <= 105 && event.keyCode !== 101) ||
      event.keyCode === 44 || event.keyCode === 46)) {
      event.preventDefault();
    }
  }

  getPaymentMethods() {
    this.userService.checkStatus(this.userService.userData.Status).then((val) => {
      if (val === 'noRedirect') {
        this.IsPaymentOptions = false;
        this.user = JSON.parse(localStorage.getItem('playerDetails'));
        let result;
        if (
          (this.gpmData || this.getpmService.gpm_tmp)
          && (this.gpmData.hasOwnProperty('message') || this.getpmService.gpm_tmp.message.hasOwnProperty('message'))
          && (this.gpmData.message.PaymentOptions || this.getpmService.gpm_tmp.message.PaymentOptions) &&
          (this.gpmData.message.PaymentOptions.length > 0 || this.getpmService.gpm_tmp.message.PaymentOptions.length > 0)
        ) {
          result = this.gpmData || this.getpmService.gpm_tmp;
          this.getPaymentMethodFlow(result);
        } else {
          this.getpmService.getPaymentMethods().then(output => {
            if (output === 'GPM') {
              this.getPaymentMethodFlow(this.getpmService.gpm_tmp);
            }
          });
        }
      }
    });
  }

  getPaymentMethodFlow(result) {
    if (this.userService.userData
      && this.userService.userData.Balance === '0.00'
      && this.userService.userData.BonusBalance === '0.00'
      && this.userService.userData.RealBalance === '0.00'
      && (window.location.href.indexOf('games') > -1 || window.location.href.indexOf('casino') > -1)) {
      this.noFunds = true;
    }
    if (result && result.message.PaymentOptions) {
      if (result.message.PaymentOptions.length) {
        this.IsPaymentOptions = true;
      }
      this.payment_methods = result.message.PaymentOptions;
      if (result.message.Incentive && result.message.Incentive.Type) {
        this.pm_incentive = result.message.Incentive;
      } else {
        this.resetBonusDetails();
      }
      this.paystackSupport.pmsCounter = this.payment_methods.length;
      this.noMethods = false;
      let index = 0;
      this.payment_methods.forEach(element => {
        this.chosenOption = '&paymentOptionType=' + element.paymentMethodName +
          '&paymentOptionId=' + element.userPaymentOptionId;
        if (element.paymentMethodName === 'Card') {
          if (element.cardBrand === 'MASTERCARD' || element.cardBrand === 'VISA') {
            element.selectDisplayName = element.upoData.ccCardNumber;
          } else {
            element.selectDisplayName = '<span>' + element.cardBrand + ' </span>' +
              element.upoData.ccCardNumber;
          }
          element.selectImageClass = element.upoData.brand;
        } else {
          element.selectDisplayName = element.paymentMethodDisplayName;
          element.selectImageClass = element.paymentMethodName;
        }
        if (element.isDefault === true && !localStorage.getItem('freshAddedPaymentMethodId')) {
          this.selected_method = '&paymentOptionType=' + element.paymentMethodName +
            '&paymentOptionId=' + element.userPaymentOptionId;
          this.chosenOption = '&paymentOptionType=' + element.paymentMethodName +
            '&paymentOptionId=' + element.userPaymentOptionId;
          this.selected_method_class = element.paymentMethodDisplayName;
          this.selected_method_class_brand = element.upoData ? element.upoData.brand : '';
          this.selected_method_show_name = element;
        }
        if (localStorage.getItem('freshAddedPaymentMethodId')) {
          const paymentId = parseInt(localStorage.getItem('freshAddedPaymentMethodId'), 10);
          if (paymentId === element.userPaymentOptionId) {
            this.selected_method = '&paymentOptionType=' + element.paymentMethodName +
              '&paymentOptionId=' + element.userPaymentOptionId;
            this.chosenOption = '&paymentOptionType=' + element.paymentMethodName +
              '&paymentOptionId=' + element.userPaymentOptionId;
            this.selected_method_class = element.paymentMethodDisplayName;
            this.selected_method_class_brand = element.upoData ? element.upoData.brand : '';
            this.selected_method_show_name = element;
            setTimeout(() => {
              localStorage.removeItem('freshAddedPaymentMethodId');
            }, 500);
          }
        }
        if (element.paymentMethodName == 'apmgw_wire_transfer') {
          this.wireTransferBanks = []
          element.banks.forEach(v => {
            v.selectDisplayName = v.name
            v.selectImageClass = v.bank_id
            this.wireTransferBanks.push(v)
          })
        }
        index++;
      });
      this.payment_methods = this.payment_methods.filter(pm => {
        if (pm.paymentMethodName == 'apmgw_wire_transfer' && !this.wireTransferBanks.length) return false;
        return pm.selectDisplayName;
      });
      this.enableButton = true;
    } else {
      this.noMethods = true;
      this.enableButton = true;
    }
    if (window.location.href.indexOf('casino') <= -1 || this.freshRegistered === false) {
      this.isAddFundsModalOpen = true;
    }
  }

  doNotOverlapInput() {
    if (this.modalContainer.nativeElement) {
      setTimeout(() => {
        this.modalContainer.nativeElement.scrollIntoView({behavior: 'smooth', block: 'end'});
      }, 500);
    }
  }

  onClickMethod(value, brand?) {
    this.selected_method_class = value;
    this.selected_method_class_brand = brand ? brand : '';
  }

  onSelectMethod(value) {
    if (!value) {
      this.chosenOption = 0;
    } else {
      this.selected_method = `&paymentOptionType=${value.paymentMethodName}&paymentOptionId=${value.userPaymentOptionId}`;
      this.chosenOption = `&paymentOptionType=${value.paymentMethodName}&paymentOptionId=${value.userPaymentOptionId}`;
      this.paymentNameForText = value.paymentMethodName;
    }
  }

  onSelectBank(value) {
    this.selectedBank = value ? value.bank_id : null;
    this.selectedBankDetails = value;
  }

  deposit(amount) {
    const cookieIncentiveCodeExists: boolean = this.cookieService.check('incentiveCode');
    let incentiveCode = '';
    if (cookieIncentiveCodeExists) {
      incentiveCode = this.cookieService.get('incentiveCode');
      this.cookieService.delete('incentiveCode');
    }
    const url = this.router.url.split('?')[0];
    this.language = localStorage.getItem('pageLanguage');
    this.paymentCover = true;
    setTimeout(() => {
      this.paymentCoverShow = true;
    }, 200);
    this.paymentSuccess = false;
    this.error52 = false;
    this.error69 = false;
    this.errorDefault = false;
    let body;
    if (this.router.url === '/' + this.language + '/casino') {
      this.casino = true;
      this.color = 'dark';
    } else {
      this.casino = false;
      this.color = 'light';
    }

    if (this.gameId !== -1) {
      body = 'amount=' + amount + '&email=noturbusiness' +
        this.chosenOption + '&sessionId=' + this.user.sessionId + '&apmCallbackSuccessUrl=';
      if (this.chosenOption.includes('Card')) {
        body += encodeURIComponent(globals.frontDomain + '/' + this.language + '/cart/payment-processing/') +
          '&apmCallbackFailUrl=' + encodeURIComponent(globals.frontDomain + '/' + this.language + '/cart/payment-processing/');
        localStorage.setItem('success3d', globals.frontDomain + url + '?success-deposit=true&deposit-amount=' + amount +
          '&game-id=' + this.gameId + '&trigger-modal=true');
        localStorage.setItem('fail3d', globals.frontDomain + url + '?paymentStatus=fail');
      } else {
        body += encodeURIComponent(
            globals.frontDomain + url +
            '?success-deposit=true&deposit-amount=' + amount + '&game-id=' + this.gameId + '&trigger-modal=true') +
          '&apmCallbackFailUrl=' + encodeURIComponent(
            globals.frontDomain + url + '?paymentStatus=fail');
      }
    } else {
      body = 'amount=' + amount + '&email=noturbusiness' +
        this.chosenOption + '&sessionId=' + this.user.sessionId + '&apmCallbackSuccessUrl=';
      if (this.chosenOption.includes('Card')) {
        body += encodeURIComponent(globals.frontDomain + '/' + this.language + '/cart/payment-processing/') +
          '&apmCallbackFailUrl=' + encodeURIComponent(globals.frontDomain + '/' + this.language + '/cart/payment-processing/');
        localStorage.setItem('success3d', globals.frontDomain + url + '?success-deposit=true&deposit-amount=' + amount +
          '&game-id=' + this.gameId + '&trigger-modal=true');
        localStorage.setItem('fail3d', globals.frontDomain + url + '?paymentStatus=fail');
      } else {
        body += encodeURIComponent(
            globals.frontDomain + url + '?success-deposit=true&deposit-amount=' + amount + '&trigger-modal=true') +
          '&apmCallbackFailUrl=' + encodeURIComponent(
            globals.frontDomain + url + '?paymentStatus=fail');
      }
    }
    if (incentiveCode && incentiveCode !== 'undefined') {
      body += '&cookieValue=' + incentiveCode;
    }

    if (this.paystackSupport.paystackMode
      && this.paystackSupport.generatedReferenceId
      && this.paystackSupport.paystackMode === 'deposit') {
      body += '&referenceId=' + this.paystackSupport.generatedReferenceId;
    }
    body += '&isDeposit=1'
    if (this.chosenOption.includes('apmgw_wire_transfer')) {
      this.isWireTransferOption = true
      body += '&wireBankId=' + this.wireTransferBanks.filter(v => v.bank_id === this.selectedBank)[0].id
    }
    this.lotteryService.postData
    (globals.appDomain + '/payments/addDeposit/' + this.user.memberId + '/paymentsAddDeposit.json', body)
      .subscribe(data => {
        if (data.message) {
          if (data.message.redirectURL && data.message.PaymentStatus === 'Pending') {
            window.location.href = data.message.redirectURL;
          } else if (data.message.PaymentStatus === 'Completed' ||
            (data.message.PaymentStatus === 'Pending' && !data.message.Post.actionUrl && !data.message.Post.paRequest)) {
            this.paymentSuccess = true;
            this.subscriptionsService.updateBalance(data.message.TotalBalance);
            this.userService.getUserDetails(this.user.sessionId, this.user.memberId, false);
            localStorage.setItem('affiliateData', JSON.stringify(data.message));
            this.subscriptionsService.emitFirstTimeAffiliate(true);
            localStorage.setItem('createAffiliateLink', 'true');
            this.subscriptionsService.emitHoldModalOberlay(true);
            localStorage.removeItem('success3d');
            localStorage.removeItem('fail3d');
            setTimeout(() => {
              this.subscriptionsService.emitCloseDepositModalSmoothly(true);
            }, 250);
            if (!this.paystackSupport.usePaystack) {
              setTimeout(() => {
                this.flipperFlip = 3;
                this.flipIt = 3;
                this.subscriptionsService.emitCloseDepositModalSmoothly(false);
                this.paymentCoverShow = false;
                this.paymentCover = false;
              }, 800);
            } else {
              this.noFunds = false;
            }
            setTimeout(() => {
              this.subscriptionsService.emitHoldModalOberlay(false);
            }, 1000);
          } else if (data.message.PaymentStatus === 'Pending' && data.message.Post.actionUrl && data.message.Post.paRequest) {
            this.info3d = true;
            const body3d = {
              PaReq: data.message.Post.paRequest,
              TermUrl: globals.appDomain + '/3dflow?paymentStatusCheck=true&transactionId=' + data.message.Post.transactionId
            };
            this.send3dPost(body3d, data.message.Post.actionUrl);
          } else if (data.message.ErrorID) {
            localStorage.removeItem('success3d');
            localStorage.removeItem('fail3d');
            const error = data.message.ErrorID;
            this.errorParams = data.message.ErrorParams;
            if (error === '052') {
              this.error52 = true;
            } else if (error === '069') {
              this.error69 = true;
            } else {
              this.errorDefault = true;
            }
          }
          setTimeout(() => {
            this.subscriptionsService.reloadCart(true);
          }, 0);
        }
      });
  } // func end

  flipOrSend() {
    if (!this.noMethods && this.IsPaymentOptions) {
      setTimeout(() => {
        this.flipIt = 2;
      }, 50);
      this.flipperFlip = 2;
    } else if (!this.IsPaymentOptions) {
      this.renderer.removeClass(document.body, 'modal-open');
      this.subscriptionsService.onlyPmStep(true);
      this.showOnlyPM = true;
      this.goToRegistration();
      this.isAddFundsModalOpen = false;
    } else {
      this.language = localStorage.getItem('pageLanguage');
      localStorage.setItem('dashboardStatus', 'add-funds');
      this.router.navigate(['/' + this.language, 'dashboard']);
      this.noFunds = false;
    }

  }

  runGame(gameId) {
    this.amountFromLink = false;
    let newGameId;
    if (gameId === -1 && gameId === '-1' && gameId === 'undefined') {
      newGameId = localStorage.getItem('gameIdFromAddDepositFromGame');
      if (newGameId) {
        gameId = newGameId;
      } else if (this.gameLauncher.gameId) {
        gameId = this.gameLauncher.gameId;
      }
    }
    this.subscriptionsService.emitCloseDepositModalSmoothly(true);
    setTimeout(() => {
      this.renderer.removeClass(document.body, 'modal-open');
      this.subscriptionsService.emitToggleContent(true);
      if (gameId !== -1 && gameId !== '-1' && gameId !== 'undefined') {
        this.subscriptionsService.closeModalNow(true);
        if (gameId) {
          this.gameLauncher.runGame(gameId, 0);
        }
      }
      this.noFunds = false;
    }, 650);
    setTimeout(() => {
      this.subscriptionsService.emitCloseDepositModalSmoothly(false);
      if (newGameId) {
        localStorage.removeItem('gameIdFromAddDepositFromGame');
      }
    }, 750);
    this.subscriptionsService.openCasinoWelcomeNow(true);
  }

  tryAgain() {
    this.paymentCoverShow = false;
    this.paymentCoverHide = true;
    setTimeout(() => {
      this.paymentCoverHide = false;
      this.paymentCover = false;
      this.errorDefault = false;
      this.error52 = false;
      this.error69 = false;
      this.secureError = false;
    }, 300);
  }

  send3dPost(obj, url) {
    const form3d = this.renderer.createElement('form');
    this.renderer.setProperty(form3d, 'method', 'POST');
    this.renderer.setProperty(form3d, 'action', url);
    const paRequest = this.renderer.createElement('input');
    this.renderer.setProperty(paRequest, 'type', 'hidden');
    this.renderer.setProperty(paRequest, 'name', 'PaReq');
    this.renderer.setProperty(paRequest, 'value', obj.PaReq);
    const termURL = this.renderer.createElement('input');
    this.renderer.setProperty(termURL, 'type', 'hidden');
    this.renderer.setProperty(termURL, 'name', 'TermUrl');
    this.renderer.setProperty(termURL, 'value', obj.TermUrl);
    this.renderer.appendChild(form3d, paRequest);
    this.renderer.appendChild(form3d, termURL);
    this.renderer.appendChild(document.body, form3d);
    form3d.submit();
  }

  paymentCancel() {
    this.isAddFundsModalOpen = false;
    this.paystackSupport.paymentCancel();
    this.subscriptionsService.closeModalNow(true);
  }

  paymentDone($event) {
    this.isAddFundsModalOpen = false;
    this.flipperFlip = 3;
    this.flipIt = 3;
    this.userService.getUser();
    this.paystackSupport.paymentDone($event);
    this.noFunds = true;

    const body = 'TransactionId=' + $event.reference;
    this.lotteryService.postData(globals.appDomain + '/payments/getTransactionStatus/deposit_status_paystack.json',
      body).subscribe(response => {
      if (response && response.message.transactionStatus === 'success') {
        this.userService.getUserDetails(this.userService.userData.sessionId, this.userService.userData.memberId, false);
      } else if (response && response.message.transactionStatus === 'pending') {
        this.router.navigate(['/' + this.showLang, 'cart', 'payment-pending']);
      } else {
        this.paymentCancel();
      }
    });
  }

  checkModalClose() {
    this.renderer.removeClass(document.body, 'modal-open');
    this.getpmService.getPaymentMethods();
    this.noFunds = false;
  }

  checkDepositInput(type) {
    if (this.selectedValue) {
      let tmpValue = this.selectedValue.toString();
      if (tmpValue.includes('.')) {
        tmpValue = tmpValue.split('.');
        if (tmpValue[1].length > 2) {
          this.selectedValue = this.selectedValue.toFixed(2);
        }
      }
    }

    if (this.minimumDepositFromBackend !== 0) {
      if (this.selectedValue < this.minimumDepositFromBackend) {
        if (type === 'keyup') {
          this.sendInfoToUserAfterSomeTime(true);
          this.blockedBecauseMinimumDeposit = true;
        } else if (type === 'focusout') {
          this.blockedBecauseMinimumDepositShowError = true;
        }
      } else {
        if (type === 'keyup') {
          this.blockedBecauseMinimumDeposit = false;
          this.blockedBecauseMinimumDepositShowError = false;
          this.sendInfoToUserAfterSomeTime(false);
        } else if (type === 'focusout') {
          this.sendInfoToUserAfterSomeTime(false);
          this.blockedBecauseMinimumDepositShowError = false;
        }
      }
    }
  }

  sendInfoToUserAfterSomeTime(show) {
    clearTimeout(this.typingTimer);
    if (!show) {
      this.blockedBecauseMinimumDepositShowError = false;
    } else {
      this.typingTimer = setTimeout(() => {
        if (show) {
          this.blockedBecauseMinimumDepositShowError = true;
        }
      }, 2000);
    }
  }

  resetBonusDetails() {
    this.pm_incentive = undefined;
  }

  getBonusDetails() {
    this.bonusService.getBonusDetails().then((resp: any) => {
      if (resp.message.Incentive && resp.message.Incentive.Type) {
        this.pm_incentive = resp.message.Incentive;
      } else {
        this.resetBonusDetails();
      }
    });
  }

  removeBonusDetails(userIncentiveId) {
    this.bonusService.cancelBonus(userIncentiveId).then(() => {
      this.showConfirmation = !this.showConfirmation;
      this.resetBonusDetails();
      this.getBonusDetails();
    });
  }

  goToDashboard(val) {
    this.renderer.removeClass(document.body, 'modal-open');
    this.noFunds = false;
    this.router.navigate(['/' + this.language, 'dashboard']);
    localStorage.setItem('dashboardStatus', val);
  }

  async writeToClipboard(str, e) {
    str.select()
    document.execCommand('copy')
    str.setSelectionRange(0, 0)
    const viewportOffset = e.srcElement.getBoundingClientRect();
    const top = viewportOffset.top + (viewportOffset.height / 2);
    const left = viewportOffset.left + viewportOffset.width + 9;
    const tooltipConfig = {
      top: top,
      left: left,
      show: true,
      message: 'Copied!',
      cssClass: 'green'
    }
    this.subscriptionsService.emitJinniTooltip(tooltipConfig);
  }
}

